/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_1 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElInfiniteScroll as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/infinite-scroll/style/css';
import { ElDrawer as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/drawer/style/css';
import { ElCheckTag as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/check-tag/style/css';
import __unplugin_components_9 from '~icons/ep/edit-pen';
import { ElTag as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElEmpty as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { ElSelect as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElInput as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import __unplugin_components_2 from '~icons/ep/search';
import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_0 from '~icons/ep/chat-dot-square';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35575760"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "帮助", -1));
const _hoisted_2 = {
  class: "comment-count"
};
const _hoisted_3 = {
  class: "count"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "color": "#5F6379",
    "font-weight": "500",
    "margin": "12px 0 5px 0"
  }
}, "评论", -1));
const _hoisted_5 = {
  key: 0,
  class: "infinite-list-wrapper",
  style: {
    "overflow": "auto"
  }
};
const _hoisted_6 = ["infinite-scroll-disabled"];
const _hoisted_7 = {
  key: 0,
  class: "mine"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  class: "info"
};
const _hoisted_10 = {
  class: "tag"
};
const _hoisted_11 = {
  key: 0,
  class: "tips"
};
const _hoisted_12 = {
  key: 1,
  class: "tips"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#5F6379",
    "margin": "20px 0",
    "font-weight": "500"
  }
}, "常用标签", -1));
const _hoisted_15 = {
  key: 0
};
import { useModel } from '../../hooks';
import Editor from '../../components/UEditor/index.vue';
import { debounce } from '../../utils';
import { ElMessageBox } from 'element-plus';
import { formatDate } from '../../utils/filter';
import { useAppStore } from '@/store/modules/app';
// 图片预览
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    commentKey: {
      type: String,
      default: ''
    },
    apis: {
      type: Object,
      default: () => ({})
    },
    uid: {
      type: Number,
      default: 0
    },
    allowComment: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const editorToolbar = [['bold', 'italic', 'underline', 'strike'], [{
      'header': 1
    }, {
      'header': 2
    }], [{
      'list': 'ordered'
    }, {
      'list': 'bullet'
    }], ['link', 'image']];
    const props = __props;
    const appStore = useAppStore();
    const type = ref('list');
    const emits = __emit;
    const visible = useModel(() => props.modelValue, val => emits('update:modelValue', val));
    const handleToggle = () => {
      visible.value = !visible.value;
    };
    const searchKey = ref(''); // 搜索关键字
    const searchTags = ref([]); // 搜索tag
    const handleSearch = () => {
      page.value = 1;
      getCommentList();
    };
    const count = ref(0); // 当前page 评论总数
    const total = ref(0); // 当前搜索 总数
    const loading = ref(false);
    const firstLoading = ref(false); // page = 1时
    const page = ref(1); // 分页
    const commentList = ref([]); // 评论列表
    const noMore = computed(() => commentList.value.length >= total.value); // 是否还有更多数据
    const disabled = computed(() => loading.value || noMore.value); // 禁用滚动加载
    // 加载更多
    const load = () => {
      if (!noMore.value) {
        page.value++;
        getCommentList();
      }
    };
    // 获取标签
    const tags = ref([]);
    const getTags = () => {
      props.apis.getTags({}).then(res => {
        if (res.code === 0) {
          tags.value = res.data.tags;
        }
      });
    };
    // 选择标签
    const checkedTags = ref([]);
    const changeTag = tag => {
      if (checkedTags.value.includes(tag)) {
        checkedTags.value = checkedTags.value.filter(item => item != tag);
      } else {
        checkedTags.value.push(tag);
      }
    };
    // 获取评论列表
    const getCommentList = () => {
      if (!props.commentKey) return;
      if (page.value === 1) {
        firstLoading.value = true;
      }
      loading.value = true;
      props.apis.getList({
        page: page.value,
        page_id: props.commentKey,
        page_size: 10,
        content: searchKey.value,
        tags: searchTags.value.join(',')
      }).then(res => {
        if (res.code === 0) {
          if (page.value === 1) {
            commentList.value = res.data.list;
          } else {
            commentList.value.push(...res.data.list);
          }
          total.value = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
        firstLoading.value = false;
      });
    };
    // 获取评论总数
    const getCount = () => {
      if (!props.commentKey) return;
      props.apis.getCount({
        page_id: props.commentKey
      }).then(res => {
        if (res.code === 0) {
          count.value = res.data.total;
        }
      });
    };
    const handleChange = debounce(function () {
      handleSearch();
    }, 1000);
    // 操作
    const commentContent = ref('');
    const confirmLoading = ref(false);
    const currentId = ref(0);
    const handleClick = (_type, data) => {
      if (_type === 'cancel') {
        currentId.value = 0;
        commentContent.value = '';
        type.value = 'list';
      } else if (_type === 'edit') {
        type.value = 'comment';
        checkedTags.value = data.tags || [];
        commentContent.value = data.content;
        currentId.value = data.id;
      } else if (_type === 'del') {
        ElMessageBox.confirm('是否确认删除?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          props.apis.del({
            id: currentId.value
          }).then(res => {
            if (res.code === 0) {
              getCommentList();
              count.value -= 1;
              handleClick('cancel');
            }
          });
        });
      } else {
        if (type.value === 'list') {
          type.value = 'comment';
        } else {
          if (!commentContent.value) {
            ElMessage.warning('评论内容不能为空!');
            return;
          }
          confirmLoading.value = true;
          const api = currentId.value ? props.apis.update : props.apis.save;
          const params = {
            content: commentContent.value,
            page_id: props.commentKey,
            tags: checkedTags.value,
            id: currentId.value
          };
          api(params).then(res => {
            if (res.code === 0) {
              if (!currentId.value) {
                count.value += 1;
              }
              page.value = 1;
              handleClick('cancel');
              getCommentList();
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      }
    };
    const previewImg = event => {
      const {
        nodeName,
        src
      } = event.target;
      if (nodeName === 'IMG' && src) {
        ElMessageBox.alert(`<img style="max-width:100%" src="${src}"/>`, '大图预览', {
          customStyle: {
            maxWidth: '800px'
          },
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true
        });
      }
    };
    const handleClose = () => {
      checkedTags.value = [];
      commentContent.value = '';
      searchKey.value = '';
      type.value = 'list';
      loading.value = false;
      firstLoading.value = false;
      currentId.value = 0;
    };
    watch(() => props.commentKey, val => {
      commentList.value = [];
      currentId.value = 0;
      getCount();
      page.value = 1;
      getCommentList();
    }, {
      immediate: true
    });
    watch(() => appStore.isOpenComment, val => {
      if (val) {
        visible.value = true;
      }
    });
    onMounted(() => {
      getTags();
    });
    return (_ctx, _cache) => {
      const _component_i_ep_chat_dot_square = __unplugin_components_0;
      const _component_el_icon = __unplugin_components_1;
      const _component_i_ep_search = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_input = __unplugin_components_4;
      const _component_el_option = __unplugin_components_5;
      const _component_el_select = __unplugin_components_6;
      const _component_el_empty = __unplugin_components_7;
      const _component_el_tag = __unplugin_components_8;
      const _component_i_ep_edit_pen = __unplugin_components_9;
      const _component_el_check_tag = __unplugin_components_10;
      const _component_el_drawer = __unplugin_components_11;
      const _directive_infinite_scroll = __unplugin_directives_0;
      const _directive_loading = __unplugin_directives_1;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "comment-bar",
        onClick: handleToggle
      }, [_createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_component_i_ep_chat_dot_square)]),
        _: 1
      }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(count) >= 100 ? '99+' : _unref(count)), 1)])]), _createVNode(_component_el_drawer, {
        "custom-class": "comment-drawer",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(visible) ? visible.value = $event : null),
        "show-close": false,
        onClose: handleClose
      }, _createSlots({
        footer: _withCtx(() => [__props.allowComment ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_unref(type) === 'comment' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: _cache[3] || (_cache[3] = $event => handleClick('cancel'))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })) : _createCommentVNode("", true), _unref(currentId) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "danger",
          plain: "",
          onClick: _cache[4] || (_cache[4] = $event => handleClick('del'))
        }, {
          default: _withCtx(() => [_createTextVNode("删除")]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => handleClick('comment'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(currentId) ? '更新' : '发表') + "评论", 1)]),
          _: 1
        }, 8, ["loading"])])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_unref(type) === 'list' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_unref(commentList).length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "暂无评论"
        })) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_withDirectives((_openBlock(), _createElementBlock("div", {
          "infinite-scroll-disabled": _unref(disabled)
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commentList), item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            class: "comment"
          }, [item.created_user_id === __props.uid ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode("我的评论")]),
            _: 1
          }), __props.allowComment ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            size: 18,
            onClick: $event => handleClick('edit', item)
          }, {
            default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
            class: "content",
            onClick: previewImg,
            innerHTML: item.content
          }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag
            }, _toDisplayString(tag), 1);
          }), 128))]), _createElementVNode("div", null, _toDisplayString(_unref(formatDate)(item.updated_at)), 1)])]);
        }), 128))], 8, _hoisted_6)), [[_directive_infinite_scroll, load]]), _unref(loading) ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Loading...")) : _createCommentVNode("", true), _unref(noMore) ? (_openBlock(), _createElementBlock("p", _hoisted_12, "没有更多...")) : _createCommentVNode("", true)], 64))])), [[_directive_loading, _unref(firstLoading)]]) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(Editor, {
          modelValue: _unref(commentContent),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(commentContent) ? commentContent.value = $event : null),
          "custom-toolbar": editorToolbar,
          "editor-height": "400px"
        }, null, 8, ["modelValue"]), _hoisted_14, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), item => {
          return _openBlock(), _createBlock(_component_el_check_tag, {
            key: item,
            checked: _unref(checkedTags).includes(item),
            onChange: $event => changeTag(item),
            style: {
              "margin": "0 8px 8px 0"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["checked", "onChange"]);
        }), 128))]))]),
        _: 2
      }, [_unref(type) === 'list' ? {
        name: "header",
        fn: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
          modelValue: _unref(searchKey),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(searchKey) ? searchKey.value = $event : null),
          placeholder: "请输入关键字"
        }, {
          append: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: handleSearch
          }, {
            default: _withCtx(() => [_createVNode(_component_i_ep_search)]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_select, {
          style: {
            "width": "100%",
            "margin-top": "10px"
          },
          modelValue: _unref(searchTags),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(searchTags) ? searchTags.value = $event : null),
          multiple: "",
          placeholder: "过滤标签",
          onChange: _unref(handleChange)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item,
              label: item,
              value: item
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "onChange"]), _hoisted_4])]),
        key: "0"
      } : undefined]), 1032, ["modelValue"])], 64);
    };
  }
});